(() => {
  if (window.ivoriScrollBoundariesReady) return;
  window.ivoriScrollBoundariesReady = true;
  let gesture;
  const scrollable = /^(auto|scroll|overlay)$/;
  const isolated = /^(contain|none)$/;
  const root = () => document.scrollingElement || document.documentElement;
  const stop = () => { gesture = undefined; };

  function start(event) {
    stop();
    if (event.touches.length !== 1 || window.visualViewport?.scale > 1) return;
    const touch = event.touches[0];
    const path = event.composedPath().filter(node => node instanceof Element);
    const target = path[0];
    if (!target || path.some(node => node.matches('.pmedia-viewport'))) return;
    const scroller = root();
    const nodes = [];
    const modal = path.find(node => node.matches('dialog[open]'));
    for (const node of path) {
      if (node === scroller || node === document.body) break;
      const style = getComputedStyle(node);
      if (style.touchAction === 'none') return;
      nodes.push({
        node,
        x: scrollable.test(style.overflowX),
        y: scrollable.test(style.overflowY),
        stopX: isolated.test(style.overscrollBehaviorX || style.overscrollBehavior),
        stopY: isolated.test(style.overscrollBehaviorY || style.overscrollBehavior)
      });
      if (node === modal) break;
    }
    gesture = {
      id: touch.identifier, startX: touch.clientX, startY: touch.clientY,
      x: touch.clientX, y: touch.clientY, target, nodes,
      locked: Boolean(modal) || getComputedStyle(scroller).overflowY === 'hidden' || getComputedStyle(document.body).overflowY === 'hidden'
    };
  }

  function canScroll(node, axis, delta) {
    const size = axis === 'x' ? 'Width' : 'Height';
    const extent = Math.max(0, node[`scroll${size}`] - node[`client${size}`]);
    let position = axis === 'x' ? node.scrollLeft : node.scrollTop;
    if (axis === 'x' && getComputedStyle(node).direction === 'rtl') {
      position = Math.abs(position);
      delta = -delta;
    }
    position = Math.max(0, Math.min(extent, position));
    return delta > 0 ? position > 1 : position < extent - 1;
  }

  function move(event) {
    if (!gesture) return;
    if (event.touches.length !== 1 || window.visualViewport?.scale > 1) { stop(); return; }
    const touch = event.touches[0];
    if (touch.identifier !== gesture.id) { stop(); return; }
    const dx = touch.clientX - gesture.x;
    const dy = touch.clientY - gesture.y;
    gesture.x = touch.clientX;
    gesture.y = touch.clientY;
    if (!gesture.axis) {
      const x = Math.abs(touch.clientX - gesture.startX);
      const y = Math.abs(touch.clientY - gesture.startY);
      if (Math.max(x, y) < 2) return;
      gesture.axis = x > y ? 'x' : 'y';
    }
    const axis = gesture.axis;
    const delta = axis === 'x' ? dx : dy;
    if (!delta || event.defaultPrevented) return;
    if (axis === 'x' && gesture.target.closest('.ivori-swipe-row,input,textarea,[contenteditable="true"]')) return;
    for (const entry of gesture.nodes) {
      if (!entry.node.isConnected || !entry[axis]) continue;
      if (canScroll(entry.node, axis, delta)) return;
      if (entry[axis === 'x' ? 'stopX' : 'stopY']) {
        if (event.cancelable) event.preventDefault();
        return;
      }
    }
    if (!gesture.locked && canScroll(root(), axis, delta)) return;
    if (event.cancelable) event.preventDefault();
  }

  document.addEventListener('touchstart', start, {passive: true, capture: true});
  document.addEventListener('touchmove', move, {passive: false, capture: true});
  document.addEventListener('touchend', stop, {passive: true, capture: true});
  document.addEventListener('touchcancel', stop, {passive: true, capture: true});
  window.addEventListener('pagehide', stop);
})();
